import { NgClass, NgStyle } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { Message } from 'primeng/message';
import { TableModule } from 'primeng/table';
import { SafeHtmlPipe } from '../../../../../core/pipes/safe-html.pipe';
import { I18nService } from '../../../../../core/services/i18n.service';
import { LayoutService } from '../../../../../layout/services/layout.service';
import { ActivationServiceResult } from '../../../../interfaces/activation/activation-service-result';
import { DialogTableDataRow } from '../../../../interfaces/dialog-table-data-row';
import { ActivationResultToTableDataMapperService } from '../../../../mapper/activation/activation-result-to-table-data-mapper.service';

@Component({
  selector: 'admin-config-result',
  imports: [
    Message,
    PrimeTemplate,
    TableModule,
    NgStyle,
    NgClass,
    SafeHtmlPipe
  ],
  templateUrl: './admin-config-result.component.html',
})
export class AdminConfigResultComponent implements OnInit {

  i18n = inject(I18nService);
  layoutService = inject(LayoutService);
  resultDataMapper = inject(ActivationResultToTableDataMapperService);

  @Input() activationResult: ActivationServiceResult;
  @Input() titleColumnWidth: string = 'auto';
  @Input() valueColumnWidth: string = 'auto';

  activationErrorMessage: string = '';
  /**
   * Result data for the shop and the contract
   */
  shopResultData: DialogTableDataRow[] = [];
  contractResultData: DialogTableDataRow[] = [];

  ngOnInit() {
    if (!this.activationResult.successful) {
      this.activationErrorMessage = this.i18n.i18nLng()['ACTIVATIONFAILED'] + '!<br>';
      this.activationErrorMessage += (this.activationResult.message + '<br>');
      this.activationErrorMessage += this.activationResult.details;
    } else {
      this.shopResultData = this.resultDataMapper.map(this.activationResult, 'SHOP');
      this.contractResultData = this.resultDataMapper.map(this.activationResult, 'CONTRACT');
    }
  }


}
